export default __webpack_public_path__ + "static/media/squirrel.8f01c3f4.webp";